/**
 * External dependencies
 */
import React, { useState } from "react";
import {
  Box,
  Text,
  Stack,
  Divider,
} from "@towersystems/towersystems-design-system";
import { connect } from "react-redux";

/**
 * Internal dependencies
 */
import PopoverMenu from "components/popover/menu";
import Gravatar from "components/gravatar";
import {
  getCurrentUserEmail,
  getCurrentUsername,
  getCurrentUserBusinessName,
} from "state/current-user/selectors";
import Item from "./item";
import { savePreference, setPreference } from "state/preferences/actions";

/**
 * Style dependencies
 */
import "./styles.scss";

const UserMenuDropdown = (props) => {
  const handleClick = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  const [isMenuVisible, setIsMenuVisible] = useState(false);

  return (
    <PopoverMenu
      className="user-menu-dropdown"
      enterExitTransitionDurationMs={50}
      onOuterAction={() => setIsMenuVisible(false)}
      isOpen={isMenuVisible}
      showArrow={false}
      content={
        <Box
          className="user-menu-dropdown__content"
          justifyContent="start"
          padding="medium"
        >
          <Stack>
            <Box
              display="flex"
              alignItems="center"
              marginBottom="large"
              paddingTop="large"
            >
              <Gravatar size={50} />
              <Box paddingLeft="medium">
                <Text size="small" weight="medium">
                  {props.businessName}
                </Text>
                <Text size="small">{props.email}</Text>
              </Box>
            </Box>
            <Box paddingTop="large" paddingBottom="medium">
              <Divider />
            </Box>
            <Item path="/me" label="Account Settings" icon="FiSettings" />
            <Box paddingTop="medium" paddingBottom="medium">
              <Divider />
            </Box>
            <Item path="/logout" label="Logout" icon="FiLogOut" />
          </Stack>
        </Box>
      }
    >
      <Box>
        <button className="topbar__gravatar-btn" onClick={handleClick}>
          <Box display="flex" alignItems="center">
            <Gravatar />
            <Box marginLeft="medium">
              <Text size="small" weight="medium">
                {props.username}
              </Text>
            </Box>
          </Box>
        </button>
      </Box>
    </PopoverMenu>
  );
};

export default connect(
  (state) => ({
    businessName: getCurrentUserBusinessName(state),
    username: getCurrentUsername(state),
    email: getCurrentUserEmail(state),
  }),
  {
    savePreference,
    setPreference,
  }
)(UserMenuDropdown);
